/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Date_LineInputs */

const vi_sinp_date_line = /** @type {(inputs: Sinp_Date_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày ..... tháng ..... năm .....`)
};

/**

* @param {Sinp_Date_LineInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_date_line = /** @type {((inputs?: Sinp_Date_LineInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Date_LineInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_date_line(inputs)
});